import { createFileRoute } from '@tanstack/react-router'

import { PlatformPage } from '@/features/platform/platform-page'

export const Route = createFileRoute('/_app/platform')({
    component: PlatformPage,
    staticData: { crumb: 'Platform' }
})
